(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["blog-posts-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
    const carousels = document.querySelectorAll('.blog-carousel');

    carousels.forEach(carousel => {
      const slideshowComponent = carousel.querySelector('slideshow-component');
      const scroller = carousel.querySelector('slideshow-slides');
      const progressIndicator = carousel.querySelector('.blog-carousel__progress-indicator');

      if (!scroller) return;

      function updateProgress() {
        if (!progressIndicator) return;

        const scrollLeft = scroller.scrollLeft;
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;

        if (maxScroll <= 0) {
          progressIndicator.style.width = '100%';
          progressIndicator.style.left = '0';
          return;
        }

        const progress = scrollLeft / maxScroll;
        const viewportRatio = scroller.clientWidth / scroller.scrollWidth;
        const indicatorWidth = Math.max(15, viewportRatio * 100);

        progressIndicator.style.width = indicatorWidth + '%';
        progressIndicator.style.left = (progress * (100 - indicatorWidth)) + '%';
      }

      scroller.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress, { passive: true });

      requestAnimationFrame(() => {
        requestAnimationFrame(updateProgress);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-accordion"] && !Shopify.designMode) return;
  try {
    // Auto-close other accordions when one opens (optional behavior)
  class FAQAccordion extends HTMLElement {
    connectedCallback() {
      this.accordions = this.querySelectorAll('accordion-custom details');
      this.autoClose = this.dataset.autoClose === 'true';
      
      if (this.autoClose) {
        this.accordions.forEach((details) => {
          details.addEventListener('toggle', (event) => {
            if (details.open) {
              // Close all other accordions in this group
              this.accordions.forEach((otherDetails) => {
                if (otherDetails !== details && otherDetails.open) {
                  otherDetails.open = false;
                }
              });
            }
          });
        });
      }

      // Add schema.org structured data for SEO
      if (this.dataset.addSchema === 'true') {
        this.addSchemaMarkup();
      }
    }

    addSchemaMarkup() {
      // Get all FAQ items
      const faqItems = [];
      this.accordions.forEach((details) => {
        const question = details.querySelector('.details__title')?.textContent.trim();
        const answer = details.querySelector('.faq-answer')?.textContent.trim();
        
        if (question && answer) {
          faqItems.push({
            "@type": "Question",
            "name": question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": answer
            }
          });
        }
      });

      if (faqItems.length > 0) {
        const schema = {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqItems
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);
      }
    }
  }

  if (!customElements.get('faq-accordion')) {
    customElements.define('faq-accordion', FAQAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-features-accordion"] && !Shopify.designMode) return;
  try {
    // Auto-close other accordions when one opens
  class ProductFeaturesAccordion extends HTMLElement {
    connectedCallback() {
      this.accordions = this.querySelectorAll('accordion-custom details');
      
      this.accordions.forEach((details) => {
        details.addEventListener('toggle', (event) => {
          if (details.open) {
            // Close all other accordions in this group
            this.accordions.forEach((otherDetails) => {
              if (otherDetails !== details && otherDetails.open) {
                otherDetails.open = false;
              }
            });
          }
        });
      });
    }
  }

  if (!customElements.get('product-features-accordion')) {
    customElements.define('product-features-accordion', ProductFeaturesAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-slider"] && !Shopify.designMode) return;
  try {
    (function() {
    // Add to Cart functionality
    var btns = document.querySelectorAll('.pcard__btn--atc');
    
    btns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var variantId = this.dataset.variantId;
        if (!variantId) return;

        var originalText = this.textContent;
        var buttonEl = this;
        
        // Disable and show loading state
        buttonEl.disabled = true;
        buttonEl.classList.add('pcard__btn--loading');
        buttonEl.textContent = 'Adding...';

        // Use the same fetch pattern as the theme
        var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? window.Shopify.routes.root + 'cart/add.js' 
          : '/cart/add.js';
        
        fetch(cartUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1
          })
        })
        .then(function(response) {
          if (response.ok) {
            return response.json();
          } else {
            return response.json().then(function(err) {
              throw new Error(err.message || 'Failed to add to cart');
            });
          }
        })
        .then(function(data) {
          // Show success state
          buttonEl.classList.remove('pcard__btn--loading');
          buttonEl.classList.add('pcard__btn--added');
          buttonEl.textContent = 'Added!';
          
          // Dispatch the theme's cart:update event (same event name used by CartAddEvent)
          // This is what the cart drawer and cart icon listen for
          var cartUpdateEvent = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'product-slider-' + variantId,
              data: {
                source: 'product-slider',
                variantId: variantId,
                itemCount: 1
              }
            }
          });
          document.dispatchEvent(cartUpdateEvent);
          
          // Reset button after delay
          setTimeout(function() {
            buttonEl.classList.remove('pcard__btn--added');
            buttonEl.textContent = originalText;
            buttonEl.disabled = false;
          }, 2000);
        })
        .catch(function(error) {
          console.error('Add to cart error:', error);
          buttonEl.classList.remove('pcard__btn--loading');
          buttonEl.classList.add('pcard__btn--error');
          buttonEl.textContent = 'Error';
          
          setTimeout(function() {
            buttonEl.classList.remove('pcard__btn--error');
            buttonEl.textContent = originalText;
            buttonEl.disabled = false;
          }, 2000);
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
